import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@web-chat-core/ui-kit';
import { usePlayAudio } from '@web-chat-core/ui-kit/hooks/usePlayAudio';
import { useUserSettingsContext } from 'contexts';
import { AudioBars } from 'ui/components/AudioBars/AudioBars';
import { StyledButton, StyledIcon, Description } from './view';

interface SpeakerTestButtonProps {
    withDescription?: boolean;
    isTransparent?: boolean;
}

export const SpeakerTestButton = ({ withDescription = false, isTransparent = true }: SpeakerTestButtonProps) => {
    const { t } = useTranslation();

    const { audioOutputDeviceId, speakerVolume } = useUserSettingsContext();
    const { play, stop, isPlay } = usePlayAudio('./speaker_test.mp3', {
        deviceId: audioOutputDeviceId,
        volume: speakerVolume,
    });

    const handleClick = () => {
        if (!isPlay) play();
    };

    const renderDescription = () => {
        if (isPlay) {
            return (
                <Typography variant="caption3" colorVariant="second">
                    {t('vks_microphone_no_sound_select_other_device')}
                </Typography>
            );
        }
        return '';
    };

    useEffect(() => {
        return () => stop();
    }, []);

    return (
        <>
            <StyledButton
                key="check-speaker-button"
                onClick={handleClick}
                $isDisabled={isPlay}
                $isTransparent={isTransparent}
            >
                {isPlay ? <AudioBars /> : <StyledIcon icon="icVolume" size={24} colorVariant="basic" />}
                <Typography variant="body3" colorVariant="base">
                    {isPlay ? t('vks_microphone_playing_tone') : t('vks_microphone_check_sound')}
                </Typography>
            </StyledButton>
            {withDescription && <Description>{renderDescription()}</Description>}
        </>
    );
};
